// extracted by mini-css-extract-plugin
export default {"iconComponent":"IconComponent_iconComponent__TXZ5u"};